// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1GlsA","inner":"Footer_inner__35MB7","nextIcon":"Footer_nextIcon__3-WdD","innerLeft":"Footer_innerLeft__22tSm"};